import { createStore } from "vuex";
import auth_store from '@/modules/auth/store/auth_store';
import softphone_store from '@/modules/softphone/store/softphone_store';
import pbxCloud_store from "@/modules/pbxCloud/store/pbxCloud_store";
import webMeetings_store from "@/modules/videoConferencia/store/webMeetings_store";
import crm_store from "@/modules/crm/store/crm_store";
import fxCrm_store from "@/modules/fxCrm/store/fxCrm_store";
import reportesCrm_store from "@/modules/reportesCrm/store/reportesCrm_store";
import fxReport_store from "@/modules/reportesFxCrm/store/fxReport_store";

import chat from '@/store/modules/chat';
import conversation from '@/store/modules/conversation';
import chatAttachments from '@/store/modules/chatAttachments';
import ui from '@/store/modules/ui';
import realtime from '@/store/modules/realtime';
import auth from '@/store/modules/auth';
import contact from '@/store/modules/contact';
import template from '@/store/modules/template';
import survey from '@/store/modules/survey';
import admin_store from "../modules/admin/store/admin_store";
import SipMovil_store from "../modules/SipMovil/store/SipMovil_store"
import fexeria_store from "../modules/fexeria/store/fexeria_store"

const store = createStore({
    modules:{
        auth_store,
        softphone_store,
        pbxCloud_store,
        webMeetings_store,
        crm_store,
        fxCrm_store,
        admin_store,
        reportesCrm_store,
        SipMovil_store,
        fxReport_store,
        fexeria_store
    }
})

store.registerModule('ui', ui);
store.registerModule('chat', chat);
store.registerModule('conversation', conversation);
store.registerModule('chatAttachments', chatAttachments);
store.registerModule('realtime', realtime);
store.registerModule('auth', auth);
store.registerModule('contact', contact);
store.registerModule('template', template);
store.registerModule('survey', survey);

export default store